import { GoogleProductName } from '../googleIntegration/types';

import { AccountType } from './types';

export const originProductToAccountTypeMap = {
  [GoogleProductName.AD_MANAGER]: AccountType.GAM,
  [GoogleProductName.ADMOB]: AccountType.ADMOB,
};
